// Zone API calls — maps 1:1 to the backend's /zones endpoints.
import request from "../../utils/request";

export function getAllZones(params) {
  return request("/zones", {
    method: "GET",
    params,
  });
}

export function doCreateZone(params) {
  return request("/zones", {
    method: "POST",
    data: params,
  });
}

export function doUpdateZone(params) {
  return request(`/zones/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDetailZone(id) {
  return request(`/zones/${id}`, {
    method: "GET",
  });
}

export function doDeleteZone(id) {
  return request(`/zones/${id}`, {
    method: "DELETE",
  });
}

export function doReGeocodeZone(id) {
  return request(`/zones/${id}/re-geocode`, {
    method: "POST",
  });
}
